import {Organization} from "@App/types";
import {Organizations} from "@App/types/enums";

export const OrganizationHasCheckedByBadge = (organization: Organization) => {
    return ![Organizations.DBCONNECT].includes(organization?.id);
}



export const OrganizationIsArval = (organization: Organization) => {
    return organization?.id == Organizations.ARVAL;
}


export const OrganizationIsRepareo = (organization: Organization) => {
    return organization?.id == Organizations.REPAREO;
}


export const OrganizationIsLeaseplan = (organization: Organization) => {
    return organization?.id == Organizations.LEASEPLAN;
}


export const OrganizationIsMobilityConcept = (organization: Organization) => {
    return organization?.id == Organizations.MOBILITYCONCEPT;
}


export const OrganizationIsDBConnect = (organization: Organization) => {
    return organization?.id == Organizations.DBCONNECT;
}


export const OrganizationIsFinn = (organization: Organization) => {
    return organization?.id == Organizations.FINN;
}


export const OrganizationIsDeutscheLeasing = (organization: Organization) => {
    return (organization?.id == Organizations.DEUTSCHELEASING || organization?.id == Organizations.DEUTSCHELEASINGBOSCH);
}

export const OrganizationIsAkf = (organization: Organization) => {
    return organization?.id == Organizations.AKF;
}

export const OrganizationIsAkfLangzeitmiete = (organization: Organization) => {
    return organization?.id == Organizations.AKFLANGZEITMIETE;
}

export const OrganizationIsNio = (organization: Organization) => {
    return organization?.id == Organizations.NIO;
}


export const OrganizationIsMeinAuto = (organization: Organization) => {
    return organization?.id == Organizations.MEINAUTO;
}


export const OrganizationIsGeneralMotors = (organization: Organization) => {
    return organization?.id == Organizations.GENERALMOTORS;
}

export const OrganizationIsFleethub = (organization: Organization) => {
    return organization?.id == Organizations.FLEETHUB;
}

export const OrganizationIsAkfOrAkfLangzeitmiete = (organization: Organization) => {
    return (OrganizationIsAkf(organization) || OrganizationIsAkfLangzeitmiete(organization));
}

export const OrganizationIsASS = (organization: Organization) => {
    return organization?.id == Organizations.ASS;
}

export const OrganizationIsAthlon = (organization: Organization) => {
    return organization?.id == Organizations.ATHLON;
}

export const OrganizationIsAyvens = (organization: Organization) => {
    return organization?.id == Organizations.AYVENS;
}


